import { Hit } from 'instantsearch.js';
import { Highlight as ISHighlight } from 'react-instantsearch';

type HighlightProps = {
  hit: Hit;
  attribute: string;
};

const Highlight: React.FC<HighlightProps> = ({ attribute, hit }) => {
  return (
    <span className="tw-line-clamp-1">
      <ISHighlight
        hit={hit}
        attribute={attribute}
        classNames={{ highlighted: 'tw-font-semibold' }}
        highlightedTagName="span"
      />
    </span>
  );
};

export default Highlight;
